import React, { useState, useEffect } from "react";
import helpIcon from "../../assets/svg/help.svg";
import { useNavigate } from "react-router-dom";
import {
  getOrgLogoApi,
  getProfileDetailsApi,
  getOrgListApi,
} from "./common-api";
import ReportAnIssueModal from "../common/report-an-issue-modal";
import issue from "../../assets/svg/issue.svg";
import ProfilePopup from "./ProfilePopup";
import { Toast, ToastContainer } from "react-bootstrap";
import { useGlobal } from "../../GlobalContext";

export const Navbar = ({ pageTitle }) => {
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const { setHeaderDetails, headerDetails } = useGlobal();
  const navigate = useNavigate();

  // const [profileDetail, setProfileDetail] = useState({});
  const [showComplaintModule, setShowComplaintModule] = useState(false);

  const [orgLogo, setOrgLogo] = useState("");
  const [orgName, setOrgName] = useState("");
  const [firstLetter, setFirstLetter] = useState("");
  const [showProfile, setShowProfile] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const onSuccess = (response) => {
    console.log("response", response);
    setSnackbarMessage(response.message ?? "");
    setSnackbarStatus(response.success ?? "");
    handleSnackbarShow();
    setShowComplaintModule(false);
  };
  useEffect(() => {
    getOrgList();
    getOrgLogo();
    if (!headerDetails || Object.keys(headerDetails).length === 0) {
      getProfileDetails();
    }
  }, []);

  const [orgList, setOrgList] = useState([]);
  const getOrgList = async () => {
    console.log("Getting org list");
    const response = await getOrgListApi(8);
    console.log(response.data);
    if (response.status === 200) {
      console.log(response.data.orgs);
      if (response.data.success === true) {
        setOrgList(response.data.orgs ?? []);
      }
    }
  };
  const getOrgLogo = async () => {
    try {
      const response = await getOrgLogoApi();
      if (response.success === true) {
        /*  setheaderDetails(response.user ?? {}); */
        setOrgLogo(response.image ?? "");
        setOrgName(response.org_name ?? "....");
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getProfileDetails = async () => {
    try {
      const response = await getProfileDetailsApi();
      if (!response) {
        console.error("No response received from API");
        return;
      }
      if (response.status === 200 && response.data?.success) {
        setHeaderDetails(response.data.user);
        setFirstLetter(
          response.data.user?.first_name
            ? response.data.user.first_name.charAt(0)
            : "",
        );
      }
    } catch (err) {
      console.error("Error in getProfileDetails:", err);
    }
  };

  return (
    <>
      {showComplaintModule && (
        <ReportAnIssueModal
          onSuccess={onSuccess}
          onCancel={() => {
            setShowComplaintModule(false);
          }}
        />
      )}
      <div
        className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom bg-white custom-navbar-sticky"
        style={{ height: "60px" }}
      >
        <div>
          {pageTitle && (
            <h6 className="m-0 fw-semibold text-secondary">{pageTitle}</h6>
          )}
        </div>

        <div className="d-flex align-items-center gap-3">
          <div className="right_divs">
            <button
              onClick={() => {
                setShowComplaintModule(true);
              }}
              type="button"
              className="right_divs px-2"
              style={{
                width: "152px",
                height: "36px",
                display: "flex",
                alignItems: "center",
                columnGap: "8px",
                fontSize: "13px",
                border: "none",
                borderRadius: "12px",
                backgroundColor: "#F8F8F8",
                color: "#172B4D",
                fontWeight: "500",
              }}
            >
              <img
                src={issue}
                alt="issue"
                srcSet=""
                style={{ width: "20px", height: "20px", cursor: "pointer" }}
              />
              <span>Report an issue</span>
            </button>
          </div>
          {/* <img
          src={helpIcon}
          alt="Help"
          style={{ width: "20px", height: "20px", cursor: "pointer" }}
        /> */}
          <div
            className="px-2"
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/help");
            }}
          >
            <img
              src={helpIcon}
              alt="help"
              style={{ width: "20px", height: "20px", cursor: "pointer" }}
            />
          </div>
          {/* <div
            className="help-btn"
            style={{ cursor: "pointer" }}
            onClick={() => setShowComplaintModule(true)}
          >
            <IssueIcon width={20} height={20} />
          </div>

          <div
            className="help-btn"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/help")}
          >
            <HelpIcon />
          </div>
           */}
          <div
            onClick={() => {
              setShowProfile(!showProfile);
            }}
            style={{ cursor: "pointer", paddingRight: "16px" }}
          >
            {headerDetails?.profile_image ? (
              <img
                src={headerDetails.profile_image}
                style={{
                  height: "40px",
                  borderRadius: "100%",
                  width: "40px",
                  objectFit: "cover",
                }}
                alt="Profile"
              />
            ) : (
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "100px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#7525B1",
                  flexShrink: 0,
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "700",
                    color: "#FFFFFF",
                    lineHeight: "1",
                  }}
                >
                  {(() => {
                    const first = headerDetails?.first_name ? headerDetails.first_name.trim().charAt(0).toUpperCase() : "";
                    const last = headerDetails?.last_name ? headerDetails.last_name.trim().charAt(0).toUpperCase() : "";
                    return `${first}${last}` || first || "U";
                  })()}
                </div>
              </div>
            )}
          </div>
          {showProfile && (
            <ProfilePopup
              orgList={orgList}
              profileDetail={headerDetails}
              onClose={() => setShowProfile(false)}
              orgLogo={orgLogo}
              orgName={orgName}
              callProfileFunc={getProfileDetails}
            />
          )}
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};
